/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchProductsLayout = {
    /**
     * Scroll to the clicked product.
     * This is used to scroll to the clicked product when the user
     * navigates back from PDP to the category page.
     * @param {string} selector
     */
    scrollToClickedProduct(selector) {
        const clickedProduct = document.getElementById(selector);
        if (clickedProduct) {
            history.scrollRestoration = 'manual';
            clickedProduct.scrollIntoView(true);
        } else {
            this.clickedProductSelector = "";
            console.warn("Product not found with selector: " + selector);
        }
    },
    /**
     * Focus on the first product of the loaded products.
     * This is used to improve the accessibility of the product list.
     * Used by the load more products button.
     * @param event
     */
    setFocusOnProduct(event) {
        const item = document.querySelector(`[data-page='${event.detail.page}']`);
        if (item) {
            document.activeElement.blur();
            item.scrollIntoView(true);
            item.focus();
        } else {
            console.error("Product not found with page: " + event.detail.page);
        }
    },
    /**
     * Handle product click event.
     * This is used to store the clicked product ID in the store.
     * @param {Event} event
     */
    handleProductClick(event) {
        const productItem = event.target.closest(".product-item");
        if (productItem) {
            this.clickedProductSelector = productItem.id;
            this.clickedProductPage = Number(new URLSearchParams(window.location.search).get("p")) || 1;
        }
    }
}

export default liveSearchProductsLayout;
